const title = "meta[name='title']";
const canon = "link[rel='canonical']";
const head = document.head;
export default (names, nextDocument) => {
    const newTitle = nextDocument.querySelector(title);
    head.querySelector(title).setAttribute("content", newTitle.content);
    // update canonical link
    const newCanonical = nextDocument.head.querySelector(canon);
    head.querySelector(canon).setAttribute("href", newCanonical.href);
    names.forEach((name) => {
        const selector = `meta[name=${name}]`;
        const metaElement = nextDocument.querySelector(selector);
        document.head
            .querySelector(selector)
            .setAttribute("content", metaElement.content);
    });
};
